import { render, staticRenderFns } from "./ManagerShiftsHousesRegistryScrollFixTable.vue?vue&type=template&id=27e68b1f&lang=pug&"
import script from "./ManagerShiftsHousesRegistryScrollFixTable.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftsHousesRegistryScrollFixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports